import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  Output
} from '@angular/core';
import { SecondaryLinksSEO } from '../../secondary-links-seo/models/secondary-links-seo.interfaces';
import { IdType } from '../models/nav-links.enums';
import {
  NavigationUIMenuKeys,
  NavItemLinks,
  PrimaryNavActionEvent,
  SecondaryNavActionEvent
} from '../models/nav-links.interfaces';

@Component({
  selector: 'idp-nav-links-base',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './nav-links-base.component.html',
  styleUrls: ['./nav-links-base.component.scss']
})
export class NavLinksBaseComponent {
  @Input() content: NavItemLinks = {} as NavItemLinks;
  @Input() secondaryContent: SecondaryLinksSEO = {} as SecondaryLinksSEO;
  @Input() selectedNav!: string | null;
  @Input() selectedSecNav: string | null = null;
  @Input() isSlimHeader = false;
  @Input() isHome = false;
  @Input() inMobile = false;
  @Output() analyticsEvent = new EventEmitter<{
    id: NavigationUIMenuKeys;
    label?: string;
  }>();

  @Output() primaryNavAction = new EventEmitter<PrimaryNavActionEvent>();
  @Output() secondaryNavAction = new EventEmitter<SecondaryNavActionEvent>();
  _el = inject(ElementRef);
  cdr = inject(ChangeDetectorRef);
  isVisible = false;
  previousSelectedPrimaryNav = '';

  onSecondaryNavAction(
    type: 'click' | 'mouseout' | 'mouseover' | 'key',
    id?: string
  ): void {
    if (type === 'mouseover' && id) {
      this.selectedNav = '';
      this.selectedSecNav = id;
      this.secondaryNavAction.emit({
        type,
        secondaryId: id,
        id: IdType.SECONDARY
      });
    }

    this.cdr.detectChanges();
  }

  onSecondaryNavActionToggle(id: string): void {
    this.selectedSecNav = id;
    this.secondaryNavAction.emit({
      type: 'click',
      secondaryId: id,
      id: IdType.SECONDARY
    });
  }
}
